module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAAlElEQVQoU+2SIQ5CMRBEd9J/ilruQIIGh+AW7SUQK7jE9BYIHGiS7/BgKzgDzZKKEgQ/xeBYOfsyYmZAUkVkCeAhE2dmg4ickFK6lFI2U2DTnXN7kLwDOPRgM1tX53MIYdGDK/eHW0o/ToPkFcCuV4qZbWvdn+CZiNzeDRo8xhjn7aGqg/f+mHNeqepriSTH6vz1RJ9HCHQbI26t4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/telphone.png
// module id = 2+ui
// module chunks = 1